import React from "react";
import { Link } from "react-router-dom";
import { SITE_SETTINGS } from "src/constants/common";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t py-10 mt-20">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8 text-gray-700">
        <div>
          <h3 className="font-bold text-indigo-600 text-xl mb-3">
            {SITE_SETTINGS.NAME}
          </h3>
          <p className="text-sm text-gray-600">
            A smart inventory management SaaS helping businesses streamline
            stock, purchase, and sales operations effortlessly.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-3">Resources</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-3">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li>
              Email:{" "}
              <a
                href={`mailto:${SITE_SETTINGS.CONTACT_EMAIL}`}
                className="text-indigo-600"
              >
                {SITE_SETTINGS.CONTACT_EMAIL}
              </a>
            </li>
            <li>Phone: {SITE_SETTINGS.CONTACT_NUMBER}</li>
            <li>Address: {SITE_SETTINGS.ADDRESS}</li>
          </ul>
        </div>
      </div>

      <div className="text-center text-sm text-gray-500 mt-10 border-t pt-4">
        © {new Date().getFullYear()} {SITE_SETTINGS.NAME}. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
